import BaseApiService from './baseApiService';
import {
    TicketEditsFilter,
    ExportTicketEditsRequest,
    ImportReportDataResult,
    TicketEditsDto,
    GetTicketEditsRequest
} from '../contracts';
import { RcFile } from 'antd/lib/upload';

class TicketEditsApiService extends BaseApiService {
    loadTicketEdits = async (request: GetTicketEditsRequest) => {
        return await this.post<TicketEditsDto, GetTicketEditsRequest>('report-data/ticket-edits', request);
    };

    importTicketEdits = async (file: RcFile) => {
        const form = new FormData();
        form.append('file', file);
        return await this.post<ImportReportDataResult, FormData>('report-data/ticket-edits/import', form);
    };

    exportTicketEdits = async (filter: TicketEditsFilter) => {
        return await this.downloadFilePost<ExportTicketEditsRequest>('report-data/ticket-edits/export/tsv', {
            filter
        });
    };

    deleteCouponEdits = (ids: number[]) => {
        return this.delete('report-data/ticket-edits', { data: { ids } });
    };
}

export default new TicketEditsApiService();
